import React from "react";
import { useSelector } from "react-redux";
import { CredentialsType } from "../common/interfaces/credentials/Credentials";
import BasicAuthPage from "./types/basic/BasicAuthPage";
import AuthToolbar from "./AuthToolbar";
import Page from "@atlaskit/page";
import TokenPage from "./types/token/TokenPage";
import Oauth2Page from "./types/oauth2/Oauth2Page";
import JwtPage from "./types/jwt/JwtPage";
import CustomHeaders from "./types/headers/CustomHeaders"
import AwsSignaturePage from "./types/aws/AwsSignaturePage";
import { isEmptyJsonObject } from "../common/utils/helper";

const DetailedPage = () => {
  const selectedCred = useSelector((state) => state.auth.selectedCred);

  const authTypePage = () => {
    if (isEmptyJsonObject(selectedCred)) {
      return "";
    }

    switch (selectedCred.type) {
      case CredentialsType.BASIC_AUTH:
        return <BasicAuthPage />;
      case CredentialsType.TOKEN:
        return <TokenPage />;
      case CredentialsType.OAUTH2:
        return <Oauth2Page />;
      case CredentialsType.JWT:
        return <JwtPage />;
      case CredentialsType.CUSTOM_HEADER:
        return <CustomHeaders />;
      case CredentialsType.AWS_SIGNATURE:
        return <AwsSignaturePage />;
      default:
        return "";
    }
  };

  return (
    <Page>
      <h4>Edit credential</h4>
      <p></p>
      {authTypePage()}
      <br />
      <AuthToolbar />
    </Page>
  );
};
export default DetailedPage;
